"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FlightDetails = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var FlightDetails = {
  actions: _propTypes.array,
  columns: (0, _propTypes.shape)({
    date: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
      value: _propTypes.string,
      fontColor: _propTypes.string
    })]),
    depart: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
      value: _propTypes.string,
      fontColor: _propTypes.string
    })]),
    origin: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
      value: _propTypes.string,
      fontColor: _propTypes.string
    })]),
    arrive: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
      value: _propTypes.string,
      fontColor: _propTypes.string
    })]),
    destination: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
      value: _propTypes.string,
      fontColor: _propTypes.string
    })]),
    bookingNumber: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
      value: _propTypes.string,
      fontColor: _propTypes.string
    })]),
    status: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
      value: _propTypes.string,
      fontColor: _propTypes.string
    })])
  }),
  bottomBorder: _propTypes.bool,
  dropdownData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    text: _propTypes.string,
    value: _propTypes.string
  })),
  labelColour: (0, _propTypes.shape)({
    label: _propTypes.string,
    text: _propTypes.string
  })
};
exports.FlightDetails = FlightDetails;
var _default = {
  PropTypes: {
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    isMobile: _propTypes.bool,
    translation: _propTypes.object,
    data: (0, _propTypes.shape)(FlightDetails),
    onOptionSelect: _propTypes.func,
    dropdownOptionsProps: _propTypes.object
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    isMobile: true,
    translation: null,
    data: {
      actions: [],
      columns: {
        date: '',
        depart: '',
        origin: '',
        arrive: '',
        destination: '',
        bookingNumber: '',
        status: ''
      },
      bottomBorder: false,
      dropdownData: [],
      labelColour: {
        label: '',
        text: ''
      }
    },
    onOptionSelect: function ref() {},
    dropdownOptionsProps: {}
  }
};
exports.default = _default;